<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-create-product-attribute-' + new Date().getTime(),
				},
				loading: false,
				types: null,
				item: {
					name: null,
					product_attribute_type_field_id: null,
				},
			}
		},
		methods: {
			open() {
				this.clearData()
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getTypes()
			},
			clearData() {
				this.item.name = null
				this.item.product_attribute_type_field_id = null
				this.errors.clear()
			},
			getTypes() {
				this.loading = true
				this.$http.get('admin/management/products/attribute/type/fields')
				.then(response => {
					this.types = response.body
					this.loading = false
				})
			},
			validate(event) {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store () {
				this.loading = true
				this.$http.post('admin/management/products/attribute/lists', this.item)
				.then(response => {
					this.close()
					this.$emit('reload')
					this.clearData()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
					this.loading = false
				}).catch(function(response) {
					console.log(response)
					this.loading = false
					this.clearData()
					this.$emit('reload')
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productAttributeLists/views/Create.vue